import { useEffect, useState } from "react";
import { contractApi } from "./defaults";

const Assets = () => {
    const [documents, setDocuments] = useState([]);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchDocuments = async (pageNum = page, limitNum = limit) => {
        setLoading(true);
        try {
            const response = await contractApi.get("/contracts", {
                params: { limit: limitNum, page: pageNum },
            });

            if (response.status === 200 && response.data.message === "Success") {
                const { page: serverPage, limit: serverLimit, totalPages, documents } = response.data;
                setDocuments(documents);
                setPage(serverPage);
                setLimit(serverLimit);
                setTotalPages(totalPages);
            } else {
                console.warn("Unexpected response format", response.data);
            }
        } catch (error) {
            console.error("Error fetching documents:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDocuments();
    }, [page, limit]);

    const handleNextPage = () => {
        if (page < totalPages) {
            setPage((prevPage) => prevPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (page > 1) {
            setPage((prevPage) => prevPage - 1);
        }
    };

    const downloadDocument = (docData) => {
        const jsonString = JSON.stringify(docData, null, 2);
        const blob = new Blob([jsonString], { type: "application/json" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `${docData.info.title || "document"}.json`;
        link.click();

        URL.revokeObjectURL(url);
    };

    const deleteDocument = async (id) => {
        try {
            const response = await contractApi.delete(`/contract/${id}`);
            if (response.status === 200) {
                setDocuments((prevDocuments) =>
                    prevDocuments.filter((doc) => doc._id !== id)
                );
            } else {
                console.error("Failed to delete document");
            }
        } catch (error) {
            console.error("Error deleting document:", error);
        }
    };

    return (
        <div>
            <div className="main-content">
                <div style={{ display: "flex", height: "95vh" }}>
                    
                    <div className="form-container">
                        <h2 className="profile-header">Your Documents</h2>
                        {loading ? (
                            <p>Loading documents...</p>
                        ) : error ? (
                            <p style={{ color: "red" }}>{error}</p>
                        ) : documents.length === 0 ? (
                            <p style={{ color: 'White' }}>No documents available</p>
                        ) : (
                            <div style={{ flex: 1 }}>
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(3, 1fr)",
                                        gap: "15px",
                                    }}
                                >
                                    {documents.map((doc) => (
                                        <div
                                            key={doc._id}
                                            onClick={() => setSelectedDocument(doc.data)}
                                            style={{
                                                position: "relative",
                                                padding: "15px",
                                                border: "1px solid #ccc",
                                                borderRadius: "5px",
                                                cursor: "pointer",
                                                backgroundColor: "#f9f9f9",
                                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                            }}
                                        >
                                            <h4>{doc.data.info.title || "Untitled Document"}</h4>
                                            <p style={{ color: 'Black' }}>Created: {new Date(doc.metadata.createdAt).toLocaleDateString()}</p>
                                            <p style={{ color: 'Black' }}>Version: {doc?.data?.info?.version || 'N/A'}</p>

                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    downloadDocument(doc.data);
                                                }}
                                                style={{
                                                    position: "absolute",
                                                    bottom: "10px",
                                                    right: "10px",
                                                    background: "transparent",
                                                    border: "none",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <img
                                                    src="https://img.icons8.com/material-outlined/24/000000/download--v1.png"
                                                    alt="Download"
                                                    style={{ width: "18px", height: "18px" }}
                                                />
                                            </button>
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    deleteDocument(doc._id);
                                                }}
                                                style={{
                                                    position: "absolute",
                                                    top: "10px",
                                                    right: "10px",
                                                    background: "transparent",
                                                    border: "none",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <img
                                                    src="https://img.icons8.com/material-outlined/24/000000/delete-sign.png"
                                                    alt="Delete"
                                                    style={{ width: "12px", height: "12px" }}
                                                />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        <div
                            style={{
                                marginTop: "auto",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "10px 0",
                            }}
                        >
                            <button
                                onClick={handlePreviousPage}
                                disabled={page <= 1}
                                style={{
                                    cursor: page <= 1 ? "not-allowed" : "pointer",
                                    padding: '10px 15px',
                                    fontSize: '16px',
                                    backgroundColor: '#333',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                }}
                            >
                                ← Previous
                            </button>
                            <span style={{ color: 'white' }}>
                                Page {page} of {totalPages}
                            </span>
                            <button
                                onClick={handleNextPage}
                                disabled={page >= totalPages}
                                style={{
                                    cursor: page >= totalPages ? "not-allowed" : "pointer",
                                    padding: '10px 15px',
                                    fontSize: '16px',
                                    backgroundColor: '#333',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                }}
                            >
                                Next →
                            </button>
                        </div>
                    </div>

                    <div className="json-output" >
                        {selectedDocument ? (
                            <pre>{JSON.stringify(selectedDocument, null, 2)}</pre>
                        ) : (
                            <p style={{ color: `#FFD700` }}>Select a document to view content</p>
                        )}
                    </div>
                </div>
            </div>
            <div className="navbar">
                <a href="/dashboard">Home</a>
                <div className="account-container">
                    <a href="#" className="account-link">My Account</a>
                    <div className="account-dropdown">
                        <a href="/user/profile">Profile</a>
                        <a href="/user/sessions">Sessions</a>
                    </div>
                </div>
                <a href="/user/logout">Logout</a>
            </div>
        </div>
    );
};

export default Assets;
